/* RESPONSIBLE TEAM: team-workflows */
import type { RenderableData } from '../renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from '../admin-summary';

interface WorkflowIntroWireFormat {
  renderable_type: RenderableType;
  entity: AdminSummaryWireFormat;
  blocks: Array<object>;
  workflow_id?: number;
}

export default class WorkflowIntro implements RenderableData {
  readonly renderableType = RenderableType.WorkflowIntro;
  readonly entity: AdminSummary;
  readonly blocks: Array<object>;
  readonly workflowId?: number;

  get creatingEntity() {
    return {
      type: EntityType.Bot,
      id: this.entity.id,
      object: this.entity,
    };
  }

  get styles() {
    return {
      backgroundColor: 'bg-beta-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-beta-container-emphasis',
    };
  }

  constructor(blocks: any[], entity: AdminSummary, workflowId?: number) {
    this.blocks = blocks;
    this.entity = entity;
    this.workflowId = workflowId;
  }

  static deserialize(json: WorkflowIntroWireFormat): WorkflowIntro {
    let entity = AdminSummary.deserialize(json.entity);
    return new WorkflowIntro(json.blocks || [], entity, json.workflow_id);
  }
}
